import React from "react";
import { RECOGNITION } from "../../data";
import SectionHead from "./SectionHead";

export default function Recognition() {
  return (
    <section className="sec">
      <div className="mx-auto max-w-[1080px] px-4 lg:max-w-[1440px] lg:px-12">
        <SectionHead
          index={RECOGNITION.index}
          center
          title={
            <>
              <span style={{ fontStyle: "italic" }}>Ascoltami bene.</span>
              <br />
              <span style={{ fontStyle: "normal" }}>Sei uno dei due</span>
              <br />
              <span style={{ fontStyle: "italic" }}>Punto.</span>
            </>
          }
        />

        <div className="grid gap-5 md:grid-cols-2 mt-10">
          {RECOGNITION.profiles.map((p, i) => (
            <div key={i} className="panel p-7">
              <div className="kicker" style={{ color: "var(--blue-2)" }}>{p.tag}</div>
              <h3 className="display mt-2" style={{ fontSize: "1.5rem" }}>{p.name}</h3>
              <div className="mt-4 flex flex-col gap-2.5">
                {p.bodyLines.map((line, j) => (
                  <p key={j} style={{ fontSize: "1rem", margin: 0 }}>{line}</p>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 max-w-[760px] mx-auto text-center lg:mt-16 lg:max-w-none lg:grid lg:grid-cols-2 lg:gap-16 lg:items-center">
          <div>
          <div className="kicker mb-5">{RECOGNITION.phrasesTitle}</div>
          <div className="flex flex-col items-center gap-2.5">
            {RECOGNITION.phrases.map((q, i) => (
              <span key={i} style={{ fontStyle: "italic", color: "var(--ink)", fontSize: "1rem" }}>{q}</span>
            ))}
          </div>
          </div>
          <p className="mt-9 lg:mt-0 lg:text-left lg:pl-16 lg:border-l lg:border-white/10" style={{ fontSize: "1.15rem", color: "var(--ink)", fontWeight: 500, lineHeight: 1.5 }}>
            Sono quasi tutti sintomi.<br />
            Il problema vero non l'hai ancora guardato, ed è esattamente lì che lavoriamo.
          </p>
        </div>
      </div>
    </section>
  );
}
